import main from "../../../menu-items/main";
import { SideNavItem } from "./NavItem";

const menuItems = {
  items: [main /*dashboard, pages, utilities, other*/] as SideNavItem[],
};

export default menuItems;
